import { Table, TableProps, Tabs, TabsProps } from "antd";
import { FC, useEffect, useMemo, useState } from "react";
import SDoc, { SDocProps } from "../SDoc";

export interface OpenTabObj {
  name?: string;
  docId: string;
}

interface TabDocTableProps {
  tableName: string;
  tableProps: TableProps;
  docProps: SDocProps;
  openTab?: OpenTabObj;
  tabProps?: TabsProps;
  onClose?: () => void;
}

enum ActiveKey {
  TABLE = "TABLE",
  DOC = "DOC",
}

const TabDocTable: FC<TabDocTableProps> = ({ tableName, tableProps, docProps, openTab, tabProps, onClose }) => {
  const [activeKey, setActiveKey] = useState<ActiveKey>(ActiveKey.TABLE);
  useEffect(() => {
    if (openTab && docProps) setActiveKey(ActiveKey.DOC)
  }, [openTab, docProps])

  const tabItems: TabsProps["items"] = useMemo(() => {
    const resTabs: TabsProps["items"] = [
      {
        key: ActiveKey.TABLE,
        label: tableName,
        children: <Table {...tableProps} />,
        closable: false,
      }
    ]
    if (openTab) {
      resTabs.push({
        key: ActiveKey.DOC,
        label: openTab.name,
        children: <SDoc {...docProps} />,
        closable: true,
      })
    }

    return resTabs;
  }, [tableName, tableProps, docProps, openTab])

  const handleEdit = (key: string | React.MouseEvent | React.KeyboardEvent, action: 'add' | 'remove') => {
    if (action === 'remove' && key === ActiveKey.DOC) {
      onClose?.();
      setActiveKey(ActiveKey.TABLE);
    }
  };

  return <Tabs hideAdd type="editable-card" activeKey={activeKey} items={tabItems} onChange={key => setActiveKey(key as ActiveKey)} onEdit={handleEdit} {...tabProps} />
};

export default TabDocTable;